/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {DelAddressDtoModel} from "@well/address-management-shell-api";
import { HandoverContactDTO } from '@well/delivery-libs/handover/domain';
import { TimeWindowDtoModel } from '@well/common-libs/time-management/domain-model';
import { NamedLocationPartnerContactVO, NamedLocationVo } from '@well/named-location/shell-api-location';
import { Maybe } from '@irian-ro/util-functions';

export class TaskHandoverDTO extends JSONable {

  uuid: Maybe<string> | undefined = undefined;
  address: Maybe<DelAddressDtoModel> | undefined = undefined;
  namedLocationVO: Maybe<NamedLocationVo> | undefined = undefined;
  timeWindowDTO: Maybe<TimeWindowDtoModel> | undefined = undefined;
  contact: Maybe<HandoverContactDTO> | undefined = undefined;
  namedLocationPartnerContactVO: Maybe<NamedLocationPartnerContactVO> | undefined = undefined;
  companyName: Maybe<string> | undefined = undefined;
  loadingReference: Maybe<string> | undefined = undefined;
}
